import { USERPREST_URLS } from '../../config/config'
import { UserAPICall } from './UserRequestUtil'

export const UserPasswordReset = async (type,param) => {
  const url = USERPREST_URLS[type];
  const parameter = {
    username: param.uid,
  }

  const res = await UserAPICall(url,parameter);

  return res;


};